/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars*/
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  Modal,
  Badge,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import * as moment from "moment";
import "moment-duration-format";

// actions
import {
  resetSkills,
  resetError,
  getSkills,
  deleteSkill,
} from "../../store/skills/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

import BadgesEllipsis from "../../components/Common/BadgesEllipsis";
import BadgesEllipsisDate from "../../components/Common/BadgesEllipsisDate";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import ListUsers from "../../components/Common/ListUsers";
import { renderPagination } from "../../Libs/CrudUtils/crudUtils";

const Skills = ({ t }) => {
  const dispatch = useDispatch();

  const qtdDefault = 7;

  const {
    dataSkill,
    dataSkillDelete,
    loadingSkill,
    loadingSkillDelete,
    errorSkill,
    successSkill,
  } = useSelector((state) => state.Skill);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [skillId, setSkillId] = useState("");
  const [skillName, setSkillName] = useState("");
  const [nameFilter, setNameFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successSkill && dispatch(resetSkills()) && handleFilter(),
  };

  const handleFilter = (name) => {
    setNameFilter(name);
    setPage(1);
    dispatch(getSkills(1, qtdDefault, name));
  };

  const handleDelete = () => {
    dispatch(deleteSkill(skillId));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setSkillIdName = (skill) => {
    setSkillId(skill.id);
    setSkillName(skill.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getSkills(value, qtdDefault, nameFilter));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataSkill && dataSkill.paging) {
      if (page < dataSkill.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  useEffect(() => {
    if (dataSkillDelete && dataSkillDelete.message) {
      showToast("success", t(dataSkillDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successSkill]);

  useEffect(() => {
    if (errorSkill && typeof errorSkill === "object") {
      errorSkill.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorSkill) {
        showToast("error", t(errorSkill));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorSkill]);

  useEffect(() => {
    if (dataSkill !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataSkill]);

  useEffect(() => {
    handleFilter();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/skills"
            title={t("Dashboard")}
            breadcrumbItem={t("Skills")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="card-height">
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="4" lg="3" xl="auto" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-Skill">
                          <Link to={`/skill`}>
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Skill")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>
                  <div className="table-responsive">
                  <PerfectScrollbar>
                    <Table className="table table-centered table-nowrap">
                      <thead className="thead-light">
                        <tr>
                          <th>{t("Name")}</th>
                          <th className="wrap-pre">{t("Inactivity time")}</th>
                          <th className="wrap-pre">
                            {t("Active Chat Weight")}
                          </th>
                          <th className="wrap-pre">
                            {t("Inactive Chat Weight")}
                          </th>
                          <th className="wrap-pre">{t("Work days")}</th>
                          <th>{t("Transfer")}</th>
                          <th>{t("Fallback")}</th>
                          <th>{t("CSAT")}</th>
                          <th>{t("Users")}</th>
                          <th>{t("Action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingSkill ? (
                          <tr>
                            <td colSpan="20" align="center">
                              <Spinner
                                size="sm"
                                animation="border"
                                style={{
                                  marginTop: "40px",
                                  height: "50px",
                                  width: "50px",
                                }}
                              />
                            </td>
                          </tr>
                        ) : notFound ? (
                          <tr>
                            <td colSpan="20" align="center">
                              {t("Click search to show the records")}
                            </td>
                          </tr>
                        ) : dataSkill &&
                          dataSkill.skill &&
                          dataSkill.skill.length > 0 ? (
                          dataSkill.skill.map((skill, key) => (
                            <tr key={key}>
                              <td>
                                <Badge
                                  id={`skill-name${key}`}
                                  className="column-text-overflow-10 font-size-12 mr-2"
                                  color={"dark"}
                                  style={{
                                    backgroundColor:
                                      skill.color && "#" + skill.color,
                                  }}
                                >
                                  {skill?.name ?? "-"}
                                </Badge>
                                <UncontrolledTooltip
                                  className="tooltip-actions"
                                  placement="auto"
                                  target={`skill-name${key}`}
                                >
                                  {skill?.name ?? "-"}
                                </UncontrolledTooltip>
                              </td>
                              <td className="text-center">
                                {moment
                                  .duration(skill.inactivity_time, "seconds")
                                  .format(`d[${t("days")}] HH[h] mm[m] ss[s]`)}
                              </td>
                              <td className="text-center">
                                {skill?.weight_active ?? "-"}
                              </td>
                              <td className="text-center">
                                {skill?.weight_inactive ?? "-"}
                              </td>
                              <td>
                                {Array.isArray(skill.schedules) &&
                                skill.schedules.length > 0 ? (
                                  <BadgesEllipsisDate
                                    objItems={skill.schedules}
                                    isHoliday={false}
                                  />
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>
                                {Array.isArray(skill.transfer) &&
                                skill.transfer.length > 0 ? (
                                  <BadgesEllipsis
                                    objItems={skill.transfer}
                                  />
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>
                                {skill.fallback ? (
                                  <BadgesEllipsis objItems={[skill.fallback]} />
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td className="wrap-pre">
                                {skill?.csat?.name ?? "-"}
                              </td>
                              <td className="text-center">
                                <ListUsers data={skill.users} />
                              </td>
                              <td className="text-center">
                                <Link
                                  to={`/skill/${skill.id}`}
                                  className="text-primary"
                                  id="edit"
                                >
                                  <i
                                    className="mdi mdi-pencil font-size-18 px-2"
                                    id={`edittooltip${key}`}
                                  ></i>
                                  <UncontrolledTooltip
                                    placement="auto"
                                    target={`edittooltip${key}`}
                                  >
                                    {t("Edit")}
                                  </UncontrolledTooltip>
                                </Link>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="20" align="center">
                              {t("No matching records found")}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    </PerfectScrollbar>
                    <Modal isOpen={modal || loadingSkillDelete}>
                      <div className="modal-body font-size-18 text-center">
                        {t("Do you want to delete the skill")}
                        <strong> {skillName}</strong>?
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          onClick={toggleModal}
                          className="btn btn-danger waves-effect"
                          data-dismiss="modal"
                          style={{ backgroundColor: "#f14646" }}
                        >
                          {t("No")}
                        </button>
                        {loadingSkillDelete ? (
                          <button
                            type="button"
                            className="btn btn-secondary waves-effect waves-light"
                            disabled
                          >
                            <Spinner size="sm" animation="border" />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-secondary waves-effect waves-light"
                            onClick={() => {
                              toggleModal();
                              if (skillId) handleDelete();
                            }}
                          >
                            {t("Yes")}
                          </button>
                        )}
                      </div>
                    </Modal>
                  </div>
                  {renderPagination(
                    page,
                    dataSkill?.paging,
                    handlePreviousPage,
                    handlePage,
                    handleNextPage
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Skills);
